interface StatusBoxProps {
  title: string;
  isActive?: boolean;
}

export const StatusBox = ({ title, isActive = false }: StatusBoxProps) => {
  return (
    <div
      className={`flex-1 px-3 py-2 text-center rounded-lg border transition-all ${
        isActive ? "bg-yellow/10 border-yellow/30" : "bg-gray-50 border-gray-50"
      }`}
    >
      <span
        className={`text-sm font-medium ${
          isActive ? "text-yellow" : "text-[#999999]"
        }`}
      >
        {title}
      </span>
    </div>
  );
};

